import React from 'react'
import { EntryCardProps } from './types.d'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import { Icon } from '@toasttab/shared/src/utils/craftUtils'

const EntryCard = ({
  ctaLabel,
  ctaLink,
  image,
  linkIcons = 'none',
  sectionDescription,
  sectionHeading
}: EntryCardProps) => {
  return (
    <div
      className='overflow-hidden rounded-md border border-dark bg-white flex flex-col items-stretch'
      data-testid='entry-card'
    >
      <div className='mb-3 md:mb-2'>
        <Image {...image[0]} />
      </div>
      <div className='px-6'>
        <Typography as='h5' classes='mb-2 tracking-[0.2px]' variation='h5'>
          {sectionHeading}
        </Typography>
        <Typography as='p' classes='text-secondary' variation='default'>
          {sectionDescription}
        </Typography>
      </div>
      {ctaLabel && ctaLink ? (
        <p className='mt-auto mb-6 px-6'>
          <TextLink
            href={ctaLink}
            icon={Icon.linkIcons(linkIcons)}
            text={ctaLabel}
          />
        </p>
      ) : null}
    </div>
  )
}

export default EntryCard
